import HTMLReactParser from "html-react-parser"
import { SwiperSlide } from "swiper/react"
import { Card } from "@components/anti/Card"
import { Cover } from "@components/anti/Cover"
import { RatioImage } from "@components/anti/Image"
import Link from "@components/anti/Link"
import { SliderSwiper } from "@components/anti/Slider/Swiper"
import CardCinema from "@components/global/CardCinema"
import { dataLayerProductServices } from "lib/datalayer"
import { linkProductsServicesCinema } from "src/helper/page-url"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact } from "src/mixins"

function HomeProduct({ data, locale }) {
  const [trigger, anim] = useScrollAnim("fadeInUp", [0.125, 0.5, 0.75])
  return (
    <section className="sc-home-product py-main" ref={trigger}>
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-text mb-3 mb-md-0">
            <h2 className={`title ${anim(1)}`}>
              {data && data[`title_${locale}`]}{" "}
            </h2>
            <div className={`description ${anim(2, "fadeInUp8")}`}>
              {convertHtmlToReact(data[`description_${locale}`])}
            </div>
            <Link
              href={data?.link_url}
              withArrow
              className={`text-white text-capitalize ${anim(3)}`}
            >
              {data[`link_label_${locale}`]}
            </Link>
          </div>
          <div className="col-lg-8 col-slider">
            <SliderSwiper
              breakpoints={{
                640: {
                  slidesPerView: 1.2,
                  spaceBetween: 15,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 15,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 15,
                },
              }}
              className="home-product-slider"
            >
              {data?.data?.map((item, i) => (
                <SwiperSlide key={`home-product-slider__item-${i}`}>
                  <div
                    className={anim(4 + i)}
                    role="presentation"
                    onClick={() =>
                      dataLayerProductServices({
                        product_name: item[`title_${locale}`],
                      })
                    }
                  >
                    <CardCinema
                      slug={item.slug}
                      className={`home-product-slider__item ${item.slug}`}
                      link={`${linkProductsServicesCinema}/${item.slug}`}
                      {...item}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </SliderSwiper>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeProduct
